// @ts-expect-error TS(7006) FIXME: Parameter 'account' implicitly has an 'any' type.
const isAdmin = (account) => {
  const currentOrganization = account?.account?.currentOrganization
  return currentOrganization?.role === 'admin'
}

export default { isAdmin }
